module.exports = __webpack_public_path__ + "static/logo-mob-e4b8fdcee7e82921b75ca3e1687cbb99.svg";